export const updateOfflineStatus = (isUserOffline) => ({
  type: 'OFFLINE_STATUS_UPDATE',
  isUserOffline,
});

export const updateSlowConnectionStatus = (isConnectionSlow) => ({
  type: 'SLOW_CONNECTION_UPDATE',
  isConnectionSlow,
});
